import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-587b80e0")

_pushScopeId("data-v-587b80e0")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "timeline" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "list"
}
const _hoisted_4 = { class: "item user" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { style: {"height":"50px"} }, null, -1)
const _hoisted_6 = {
  key: 0,
  style: {"width":"100%","position":"fixed","bottom":"20px"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看过往")
_popScopeId()

import { ref, onMounted, reactive, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Dialog } from 'vant';
import { findMemberHealthQuestionRecord, findMemberHealthQuestionRecordById } from '@/api/MemberHealthQuestion'
import { useNavigateTo } from '@/composables/WxXCX';
import CollectDeviceData from '@/views/member/collectDeviceData/CollectDeviceData.vue';


export default _defineComponent({
  expose: [],
  setup(__props) {


const activeNames = ref([]);


const data = reactive({
    questionDatas: [],
    memberId: null,
    id: null,
})


function resolveHandler(questionList, questionSuggestList){
    const questionDatas = [];
        
    questionList.forEach(question => {
    const questionId = question.id
    const suggestList = questionSuggestList.filter(suggest => suggest.memberHealthQuestionId === questionId)
    
    question._reportIds = question.reportIds.split(',').filter(v=>v)
    question._resourceImages = question.resourceImages.split(',').filter(v=>v).map(v => ({url : v}) )
    question._selectedItemJson = question.selectedItemJson && JSON.parse(question.selectedItemJson) || {}
    question._selectedItemString = Object.values(question._selectedItemJson).map(vs => vs.join('，')).join('；')


    // 倒序排序。
    suggestList.sort((a,b) => Date.parse(b.createTime) - Date.parse(a.createTime))
    suggestList.forEach(v => {
        v['activeCollapseNames'] = []
        v._resourceImages = v.resourceImages.split(',').filter(v=>v).map(v => ({url : v}) )
    });


    questionDatas.push({
        question: question,
        activeCollapseNames: [],
        suggestList: suggestList,
        })

    })

    console.log("questionDatas", questionDatas);
    return questionDatas
}

const excludeBtns = ref([])

onMounted(()=>{
    const routeQuery = useRoute().query

    const id = routeQuery.id as string
    excludeBtns.value = ((routeQuery.excludeBtns || '') as string).split(",").filter(v=>v)
    
    if(id){
        data.id = id
        // 主键模式
        findMemberHealthQuestionRecordById(id).then(respData => {
            data.questionDatas = resolveHandler(respData.questionList, respData.questionSuggestList)
            data.memberId = data.questionDatas[0].question.memberId
        })
    }else{
        
        const memberId = useRoute().query.memberId as string
    
        if(!memberId){
            Dialog.alert({
                title: '错误',
                message: '未传递有效成员标识',
            }).then(() => {
            // on close
            });
            return;
        }
    
        findMemberHealthQuestionRecord(memberId).then(respData => {
            data.questionDatas = resolveHandler(respData.questionList, respData.questionSuggestList)
        })
    }


})


return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")
  const _component_van_divider = _resolveComponent("van-divider")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")
  const _component_van_collapse = _resolveComponent("van-collapse")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      (data.questionDatas.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.questionDatas, (item, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.suggestList, (suggest, suggestIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "item",
                    key: suggestIndex
                  }, [
                    _createVNode(_component_van_collapse, {
                      modelValue: suggest.activeCollapseNames,
                      "onUpdate:modelValue": ($event: any) => (suggest.activeCollapseNames = $event)
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_van_collapse_item, {
                          title: suggest.activeCollapseNames.length===0 ? suggest.createTime: '专家给出的建议',
                          name: `${item.question.id}_${suggest.id}`
                        }, {
                          default: _withId(() => [
                            _createVNode("div", null, [
                              _createVNode(_component_van_uploader, {
                                modelValue: suggest._resourceImages,
                                "onUpdate:modelValue": ($event: any) => (suggest._resourceImages = $event),
                                accept: "image/*",
                                "show-upload": false,
                                deletable: false,
                                "image-fit": "cover",
                                "preview-size": "95.33px"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (suggest.otherInfo)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_van_divider),
                                    _createVNode(_component_van_cell, {
                                      center: "",
                                      value: suggest.otherInfo
                                    }, null, 8, ["value"])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title", "name"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_van_collapse, {
                    modelValue: item.activeCollapseNames,
                    "onUpdate:modelValue": ($event: any) => (item.activeCollapseNames = $event)
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_van_collapse_item, {
                        title: item.activeCollapseNames.length===0 ? item.question.submitTime: '用户发起的咨询',
                        name: item.question.id
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_van_cell, {
                            center: "",
                            title: "# 图片"
                          }, {
                            label: _withId(() => [
                              (item.question._resourceImages.length > 0)
                                ? (_openBlock(), _createBlock(_component_van_uploader, {
                                    key: 0,
                                    modelValue: item.question._resourceImages,
                                    "onUpdate:modelValue": ($event: any) => (item.question._resourceImages = $event),
                                    accept: "image/*",
                                    "show-upload": false,
                                    deletable: false,
                                    "image-fit": "cover",
                                    "preview-size": "95.33px"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_van_cell, {
                            center: "",
                            title: "# 健康问卷",
                            label: item.question._selectedItemString
                          }, null, 8, ["label"]),
                          _createVNode(_component_van_cell, {
                            center: "",
                            title: "# 用户自我反馈",
                            label: item.question.otherInfo
                          }, null, 8, ["label"])
                        ]),
                        _: 2
                      }, 1032, ["title", "name"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ])
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5,
    (!excludeBtns.value.includes('ConsultationRecord'))
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_van_row, { class: "button-round-radius" }, {
            default: _withId(() => [
              _createVNode(_component_van_col, {
                span: "18",
                offset: "3"
              }, {
                default: _withId(() => [
                  _createVNode(_component_van_button, {
                    color: "rgba(116, 83, 213, 1)",
                    type: "primary",
                    block: "",
                    round: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(useNavigateTo)('/pages/healthQuestionnaire/consultationRecord/consultationRecord', { memberId: data.memberId,  excludeBtns: ['ConsultationRecord']  } )))
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
})
}

})